<div class="wowve-login" id="loginComponent">
  <div class="wowve-card">
    <div class="wowve-brand">
      <div class="wowve-brand__content">
        <div class="wowve-brand__logo">
          <img src="./assets/images/Logo_SF_Padrao-Branca.png" alt="WOW corp" />
        </div>
        <p class="wowve-brand__slogan">
          Onde tecnologia, criatividade e inovação se encontram — o futuro é WOW!
        </p>
      </div>
    </div>

    <div class="wowve-form">
      <form #loginForm="ngForm" (ngSubmit)="onSubmit()">
        <h1 class="wowve-form__title">Acessar WOW corp</h1>
        <p class="wowve-form__subtitle">Informe suas credenciais para acessar o recurso.</p>

        <mat-error class="wowve-form__error" *ngIf="!loginValid">
          O nome de usuário e a senha não foram reconhecidos
        </mat-error>

        <div class="wowve-field">
          <label class="wowve-field__label" for="username">Usuário:</label>
          <input
            id="username"
            class="wowve-field__input"
            type="text"
            placeholder="Usuário *"
            [(ngModel)]="username"
            name="username"
            required
            autocomplete="username" />
        </div>

        <div class="wowve-field">
          <label class="wowve-field__label" for="password">Senha:</label>
          <div class="wowve-field__wrap">
            <input
              id="password"
              class="wowve-field__input"
              [type]="hidePassword ? 'password' : 'text'"
              placeholder="Password *"
              [(ngModel)]="password"
              name="password"
              required
              autocomplete="current-password" />
            <button
              type="button"
              class="wowve-field__toggle"
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="hidePassword ? 'Mostrar senha' : 'Ocultar senha'">
              <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </div>
        </div>

        <button type="submit" class="wowve-form__submit" [disabled]="!loginForm.form.valid">
          Login
        </button>
      </form>
    </div>
  </div>
</div>
